const brandsId: Record<string, string> = {
  demo: '496',
  newtime: '1836',
  LBP: '2401',
  AQD: '2587',
  HFI: '2794',
  LGW: '2942',
  reunion: '496',
  LGW2: '2942',
  CNL: '3585',
  ALB: '3610',
};

export const getBrandId = (customerId: string): string => {
  return brandsId[customerId];
};
